import React from "react";

/**
 * Seamlessly looping marquee.
 *
 * Accepts either a list of text strings or a list of image paths (auto-detected
 * by the presence of a `/`). Logos render at a uniform height + mono tone.
 */
const Marquee = ({ items = [], speed = 22, className = "" }) => {
  const doubled = [...items, ...items];

  const renderItem = (it, idx) => {
    const isImage = typeof it === "string" && it.startsWith("/");
    if (isImage) {
      const isBoosted = /omnicom|talented/i.test(it);
      return (
        <div
          key={idx}
          className={`shrink-0 flex items-center justify-center px-2 ${
            isBoosted
              ? "h-10 md:h-12 w-24 md:w-32"
              : "h-6 md:h-8 w-24 md:w-32"
          }`}
        >
          <img
            src={it}
            alt=""
            className="h-full w-full object-contain opacity-80"
            style={{
              filter: "brightness(0) invert(1)",
              maxHeight: isBoosted ? "3rem" : "1.75rem",
              maxWidth: "6.5rem",
            }}
            loading="lazy"
            aria-hidden="true"
          />
        </div>
      );
    }
    return (
      <span
        key={idx}
        className="inline-flex items-center gap-12 font-heading font-black text-ink text-[20px] leading-none tracking-[0.16em] uppercase"
      >
        {it}
        <span className="opacity-50">✦</span>
      </span>
    );
  };

  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className="inline-flex items-center gap-12 md:gap-16 w-max animate-marquee-track"
        style={{ animationDuration: `${speed}s` }}
      >
        {doubled.map(renderItem)}
      </div>
    </div>
  );
};

export default Marquee;
